import { authentication } from '@microsoft/teams-js'
import { getCachedM365Environment } from '@helpers/environmentHelpers'

export async function getTeamsSsoToken(silent = true, throwOnError = false): Promise<string | null> {
    if (getCachedM365Environment().environment !== 'Teams') return null

    try {
        return await authentication.getAuthToken({ silent })
    } catch (error) {
        console.error('Teams SSO token acquisition failed', error)
        if (throwOnError) throw error
        return null
    }
}
